import { useTranslation } from 'react-i18next'

export function SkipToContent() {
  const { t } = useTranslation()
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only fixed top-2 left-2 z-50 px-3 py-2 rounded
        bg-mono-100 text-mono-900 shadow-emboss"
    >
      {t('skip')}
    </a>
  )
}
